import { useTranslation } from "react-i18next";


export const useTranslatedColumns = (columns) => {
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language === "en";

  return columns.map((col) => {
    const labelKey = col.label ?? col.attr;

    // Если язык английский и есть отдельный атрибут с окончанием "en"
    if (isEnglish && col.attr_en) {
      return {
        ...col,
        attr: col.attr_en,
        label: t(labelKey),
      };
    }

    // Иначе используем перевод
    return {
      ...col,
      label: t(labelKey),
    };
  });
};
